/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class LabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }

  bulkDestroy(ids) {
    return axios.delete(`${this.url}/bulk_destroy`, { data: { ids } });
  }
}

export default new LabelsAPI();
